export default function useDataService() {
  const statusDescriptions = {
    1: 'Pending',
    2: 'Approved',
    3: 'Rejected',
  };

  const statusItems = [
    {
      id: 1,
      value: 1,
      title: 'Pending',
    },
    {
      id: 2,
      value: 2,
      title: 'Approved',
    },
    {
      id: 3,
      value: 3,
      title: 'Rejected',
    },
  ];

  const jobRequestHeaders = [
    {
      id: 1,
      label: 'ID',
      columnName: 'id',
      sx: { paddingLeft: 2 },
    },
    { id: 2, label: 'Support Ticket', columnName: 'supportTicket', sx: { paddingLeft: 2 } },
    { id: 3, label: 'Escalation Ticket', columnName: 'escalationTicket', sx: { paddingLeft: 2 } },
    { id: 4, label: 'Description', columnName: 'description', sx: { paddingLeft: 2 } },
    { id: 5, label: 'Service Type ID', columnName: 'serviceType', sx: { paddingLeft: 2 } },
    { id: 6, label: 'Service Type', columnName: 'serviceTypeName', sx: { paddingLeft: 2 } },
    { id: 7, label: 'Status', columnName: 'status', sx: { paddingLeft: 2 } },
    {
      id: 8,
      label: 'Status Description',
      columnName: 'statusDescription',
      sx: { paddingLeft: 2 },
    },
    { id: 9, label: 'Requested By', columnName: 'requestedBy', sx: { paddingLeft: 2 } },
    {
      id: 10,
      label: 'Approved / Rejected By',
      columnName: 'approvedOrRejectedBy',
      sx: { paddingLeft: 2 },
    },
    { id: 11, label: 'Requested At', columnName: 'requestedBy', sx: { paddingLeft: 2 } },
    {
      id: 12,
      label: 'Approved / Rejected At',
      columnName: 'approvedOrRejectedAt',
      sx: { paddingLeft: 2 },
    },
    { id: 13, label: 'Details', columnName: 'details', sx: { paddingLeft: 2 } },
  ];

  return { statusDescriptions, statusItems, jobRequestHeaders };
}
